var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,2C3,2,2,3,2,5v3.9c0,2.1,1,3.1,3,3h3.9       c2.1,0.1,3.1-0.9,3-3V5c0.1-2-0.9-3-3-3H5z M7.1,9C6.5,9.5,5.8,9.8,4.9,9.8C4.5,9.8,4.2,9.4,4.2,9s0.3-0.8,0.8-0.8       c1,0,1.9-0.7,2.2-1.7H4.9c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h1.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7H8       c0,0,0,0,0,0h0h1c0.4,0,0.8,0.3,0.8,0.8c0,0.4-0.3,0.8-0.8,0.8H8.7C8.6,7.1,8.4,7.5,8.1,7.9C8.4,8.1,8.7,8.3,9,8.3       c0.4,0,0.8,0.3,0.8,0.8S9.4,9.8,9,9.8C8.3,9.8,7.7,9.5,7.1,9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8,16.9c0,2.8,2.3,5.1,5.1,5.1       c2.8,0,5.1-2.3,5.1-5.1s-2.3-5.1-5.1-5.1C14.1,11.9,11.8,14.1,11.8,16.9z M18.4,19l-0.2-0.3h-2.6L15.5,19       c-0.1,0.3-0.4,0.4-0.7,0.4c-0.1,0-0.2,0-0.3-0.1c-0.4-0.2-0.5-0.6-0.3-1l2.1-4.3c0.1-0.2,0.4-0.4,0.7-0.4c0.3,0,0.5,0.2,0.7,0.4       l2.1,4.3c0.2,0.4,0,0.8-0.3,1C19,19.5,18.6,19.4,18.4,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,17.2l-0.5-1.1l-0.5,1.1H17.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineTranslate);
export default __webpack_public_path__ + "static/media/outline-translate.db96795b0d7f85a1b19c959009d5eb67.svg";
export { ForwardRef as ReactComponent };